export enum LabelKey {
  BIP = 'BIP',
  FIDELITY_CHECK = 'FidelityCheck',
  SHOW_FIDELITY_SCORE = 'ShowFidelityScore',
  NEEDS_SAFETY_PLAN = 'NeedsSafetyPlan',
  ASSESS_LABEL_OVERRIDE = 'AssessLabelOverride',
  BEHAVIOR_DETAILS = 'BehaviorDetails',
  STRATEGIES_DETAILS = 'StrategiesDetails',
}

export enum LabelDefaultValue {
  BIP = 'Behavior Intervention Plan',
  FidelityCheck = 'Fidelity Check',
  ShowFidelityScore = 'Show Fidelity Score',
  NeedsSafetyPlan = 'Needs Safety Plan',
  AssessLabelOverride = 'Assessment FBA',
  StrategiesDetails = 'Strategies',
  BehaviorDetails = 'Details',
}
